var map = {
	"./937_messages.mp3": 7661,
	"./airport_bell.mp3": 1096,
	"./answer_me.mp3": 6946,
	"./bad_to_the_bone.mp3": 6937,
	"./bongo.mp3": 8394,
	"./car_lock.mp3": 7147,
	"./chewbacca.mp3": 7592,
	"./classy_notification.mp3": 2912,
	"./complete.mp3": 4286,
	"./cricket.mp3": 4256,
	"./cute_bell.mp3": 5474,
	"./drop_bass.mp3": 6770,
	"./electric_spring.mp3": 5446,
	"./executive_tone.mp3": 6262,
	"./fairydust_sound.mp3": 1126,
	"./fart.mp3": 9442,
	"./godfather_message.mp3": 2901,
	"./harry_potter_1.mp3": 7376,
	"./im_stuck_n_ur_pocket.mp3": 4452,
	"./iphone_text_message.mp3": 4598,
	"./iphone_whatsapp_2016.mp3": 4411,
	"./jarvis_excuse_me.mp3": 3493,
	"./laser.mp3": 9652,
	"./line.mp3": 577,
	"./loop_guitar.mp3": 5130,
	"./love-tone.mp3": 4164,
	"./minions_beedoo.mp3": 6121,
	"./minions_hello.mp3": 4989,
	"./minions_laugh.mp3": 7602,
	"./minions_papaya.mp3": 8633,
	"./new_email.mp3": 8186,
	"./note.mp3": 9515,
	"./notice.mp3": 2999,
	"./notification_1.mp3": 7426,
	"./notification_2.mp3": 3557,
	"./notification_3.mp3": 7424,
	"./notification_4.mp3": 2067,
	"./olive.mp3": 7620,
	"./robot.mp3": 5937,
	"./sad.mp3": 201,
	"./samurai.mp3": 4331,
	"./school_bell.mp3": 4833,
	"./shape_of_you.mp3": 8902,
	"./short.mp3": 6843,
	"./sneeze.mp3": 6153,
	"./sonar.mp3": 1020,
	"./starwars_bb_8_sound_1.mp3": 108,
	"./starwars_bb_8_sound_2.mp3": 3923,
	"./starwars_bb_8_sound_3.mp3": 5534,
	"./starwars_darth_vader.mp3": 4739,
	"./starwars_lightsaber_1.mp3": 7166,
	"./starwars_r2d2_1.mp3": 6915,
	"./starwars_r2d2_2.mp3": 6748,
	"./starwars_r2d2_3.mp3": 961,
	"./starwars_yoda.mp3": 4903,
	"./sweet.mp3": 1001,
	"./wahwahwahwahhh.mp3": 4771,
	"./waterdrop.mp3": 9323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2151;